import { Irrigate, Fertilize, Harvest, Plant, Clear, Treat } from 'components/Plans';
import RegEx from './RegEx';

const PlanHelpers = (function () {
  const getComponentForType = function (type) {
    switch (type) {
      case 'Irrigate':
        return Irrigate?.default;
      case 'Fertilize':
        return Fertilize?.default;
      case 'Harvest':
        return Harvest?.default;
      case 'Plant':
        return Plant?.default;
      case 'Clear':
        return Clear?.default;
      case 'Treat':
        return Treat?.default;
      default:
        return null;
    }
  };

  const validatePlan = function (plan) {
    let valid = {
      generalValid: true,
      specialValid: true,
    };
    const { data } = plan;

    valid.generalValid =
      RegEx.isUUID(plan.layer_id) && RegEx.isNonEmptyString(plan.type) && RegEx.isNonEmptyString(plan.time);

    if (!data) {
      valid.specialValid = false;
    } else {
      switch (data.plan_type) {
        case 'Plant':
          valid.specialValid =
            RegEx.isNonEmptyString(data.crop) && data.yield && RegEx.isNonEmptyString(data.yield_units);
          break;
        case 'Irrigate':
          valid.specialValid =
            RegEx.isPositiveNumber(data.irrigation_amount) && RegEx.isNonEmptyString(data.irrigation_units);
          break;
        case 'Fertilize':
          valid.specialValid =
            RegEx.isPositiveNumber(data.acreage) &&
            RegEx.isPositiveNumber(data.rate) &&
            RegEx.isNonEmptyString(data.fertilizer_name) &&
            RegEx.isFertilizerFormatted(data.fertilizer_grade);
          break;
        case 'Harvest':
          valid.specialValid =
            RegEx.isPositiveNumber(data.yield) &&
            RegEx.isNonEmptyString(data.yield_units) &&
            RegEx.isNonEmptyString(data.harvest_method);
          break;
        case 'Clear':
          valid.specialValid =
            RegEx.isPositiveNumber(data.cleared) &&
            RegEx.isNonEmptyString(data.cleared_units) &&
            RegEx.isNonEmptyString(data.clear_method);
          break;
        case 'Treat':
          valid.specialValid = RegEx.isNonEmptyString(data.treatment_type);
          break;
        default:
          valid.specialValid = false;
          break;
      }
    }

    return valid;
  };

  return {
    getComponentForType,
    validatePlan,
  };
})();

export default PlanHelpers;
